<template>
	<div class="pages">
		<!--列表-->
		<div id="list">
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource">
					<!--<td>{{item.day}}</td>
					<td>
						<p>交易金额：{{item.wechatCount | filterMoney}}</p>
						<p>交易手续费率：{{userInfo.rate}}</p>
						<p>交易手续费：{{item.wechatCount*userInfo.rate | filterMoney}}</p>
						<p>结算金额：{{(item.wechatCount - (item.wechatCount/100)*userInfo.rate) | filterMoney}}</p>
					</td>
					<td>
						<p>交易金额：{{item.alipayCount | filterMoney}}</p>
						<p>交易手续费率：{{userInfo.rate}}</p>
						<p>交易手续费：{{item.alipayCount*userInfo.rate | filterMoney}}</p>
						<p>结算金额：{{(item.alipayCount - (item.alipayCount/100)*userInfo.rate) | filterMoney}}</p>
					</td>
					<td>
						<p>交易金额：{{item.unionPayCount | filterMoney}}</p>
						<p>交易手续费率：{{userInfo.car_rate}}</p>
						<p>交易手续费：{{item.unionPayCount*userInfo.car_rate | filterMoney}}</p>
						<p>结算金额：{{(item.unionPayCount - (item.unionPayCount/100)*userInfo.car_rate) | filterMoney}}</p>
					</td>
					<td>{{item.count | filterMoney}}</td>
					<td>{{(item.count - (item.wechatCount*userInfo.rate + item.alipayCount*userInfo.rate + item.unionPayCount*userInfo.car_rate)) | filterMoney}}</td>
					<td>{{(item.wechatCount*userInfo.rate + item.alipayCount*userInfo.rate + item.unionPayCount*userInfo.car_rate) | filterMoney}}</td>
					<td>T+{{userInfo.settlement_cycle}}</td>-->
				</tr>
			</z-table>
		</div>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'FinanceList',
		components: {},
		data() {
			return {
				columns: ['商户名称', '开始日期', '结束日期', '结算金额', '分润金额', '实际结算'],
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					startDate:null,
					endDate:null,
//					search: '',//查询字符串
				},
				list: {
					item_total: 0,
				}
			}
		},
		mounted() {
//			this.initData();
		},
		/*
		 * 属性计算
		 */
		computed: {
		},
		/*
		 * 事件处理
		 */
		methods: {
//			...mapActions(['getFinanceList']),
		}
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
</style>


// WEBPACK FOOTER //
// ClearList.vue?fe82749a